<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Roles } from '@/constants.ts'
import EventGalleryPanel from '@/components/events/EventGalleryPanel.vue'
import EventSelect from '@/components/events/EventSelect.vue'

definePage({
  meta: {
    allowedRoles: [Roles.Admin, Roles.Manager],
  },
})

const { t } = useI18n()

// Выбор мероприятия сверху — единый EventSelect (дефолт по featured-событию).
const eventId = ref<string | null>(null)
</script>

<template>
  <section class="flex flex-col gap-4 w-full flex-1 min-h-0">
    <!-- Шапка: заголовок слева, выбор мероприятия справа -->
    <div class="flex flex-wrap items-center justify-between gap-3 w-full">
      <h1 class="text-xl font-bold">{{ t('nav.gallery') }}</h1>
      <EventSelect v-model="eventId" data-test="gallery-event-select" />
    </div>

    <EventGalleryPanel v-if="eventId" :event-id="eventId" class="flex-1 min-h-0" />
    <div v-else class="text-sm text-surface-500">{{ t('events.selectEvent') }}</div>
  </section>
</template>
